import { AcknowledgementOutcome } from '../interfaces/heavyDutyMachinery/ICheckInOut';
import { PillTone } from '../theme/creamyTokens';
import { TRANSLATIONS } from './translations';

/**
 * How each albarán outcome reads once it's settled. Exhaustive
 * Record<AcknowledgementOutcome, X> on purpose, same convention as
 * BOOKING_STATUS_TONES: adding a fourth outcome should stop the build here
 * rather than render a blank pill somewhere.
 *
 * 'AcceptedWithRemarks' is warning, not success -- the handover did happen
 * and the rental is under way, but something was put on the record and a
 * pill that reads identically to a clean acceptance would bury exactly the
 * thing this outcome exists to preserve.
 */
export const ACK_OUTCOME_TONES: Record<AcknowledgementOutcome, PillTone> = {
  Accepted: 'success',
  AcceptedWithRemarks: 'warning',
  Rejected: 'error',
};

export const ACK_OUTCOME_LABEL_KEYS: Record<AcknowledgementOutcome, string> = {
  Accepted: TRANSLATIONS.HANDOVER_ACK_ACCEPTED,
  AcceptedWithRemarks: TRANSLATIONS.HANDOVER_ACK_ACCEPTED_WITH_REMARKS,
  Rejected: TRANSLATIONS.HANDOVER_ACK_REJECTED,
};
